import { AbstractScatterVisualization } from '../visualization.abstract.scatter.component';
export class SVRGraph extends AbstractScatterVisualization {
}
